import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination-com',
  templateUrl: './pagination.com.html'
})

export class PaginationComponent implements OnChanges {

  @Input() limit = 10;
  @Input() total: number = null;
  @Input() chosenPage = 0;
  @Output() event = new EventEmitter<any>();
  model = {
    start: 1,
    highlightIndex: 0
  }

  ngOnChanges() {
    this.total = Math.ceil(this.total);
    this.model.start = 1;
    this.model.highlightIndex = this.chosenPage;
  }

  public turnToPage(index: number) {
    if (this.model.highlightIndex !== index) {
      this.model.highlightIndex = index;
      this.emitSelection();
    }
  }

  public goUpOnePage() {
    this.model.highlightIndex = (this.model.highlightIndex - 1 + this.limit) % this.limit;
    if (this.model.highlightIndex === this.limit - 1) {
      this.model.start -= this.limit;
    }
    this.emitSelection();
  }

  public goDownOnePage() {
    this.model.highlightIndex = (this.model.highlightIndex + 1) % this.limit;
    if (this.model.highlightIndex === 0) {
      this.model.start += this.limit;
    }
    this.emitSelection();
  }

  public goUpOneGroup() {
    this.model.start -= this.limit;
    this.model.highlightIndex = this.limit - 1;
    this.emitSelection();
  }

  public goDownOneGroup() {
    this.model.start += this.limit;
    this.model.highlightIndex = 0;
    this.emitSelection();
  }

  private emitSelection() {
    this.event.emit({
      source: 'pagination',
      action: 'change-range',
      data: { startPage: this.model.start + this.model.highlightIndex }
    });
  }

  get pageNumbers(): string[] {
    if (this.total) {
      return Array.from(
        { length: this.model.start + this.limit - 1 <= this.total ? this.limit : this.total - this.model.start + 1 },
        (v, i) => String(this.model.start + i)
      );
    } else {
      return null;
    }
  }

  get disableDownGroup(): boolean {
    return this.total && this.largestNumber >= this.total;
  }

  get disableUpGroup(): boolean {
    return this.model.start === 1;
  }

  get disableUpPage(): boolean {
    return this.model.start === 1 && this.model.highlightIndex === 0;
  }

  get disableDownPage(): boolean {
    return this.total && this.model.start + this.model.highlightIndex === this.total;
  }

  get largestNumber(): number {
    return this.model.start + this.limit - 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/pagination/pagination.com.ts